import { ComponentProps } from "react";
import TemplateCardFavouriteView from "./TemplateCardFavouriteView";

export default TemplateCardFavouriteView;
export type TemplateCardFavouriteViewProps = ComponentProps<
  typeof TemplateCardFavouriteView
>;
